"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTriggerJsonMapper = void 0;
const json_schema_1 = require("../../json-schema");
const timestamp_json_1 = require("../timestamp-json");
const email_trigger_model_1 = require("./email-trigger-model");
const isEmailTriggerItem = (0, json_schema_1.createValidator)(email_trigger_model_1.EmailTriggerJson);
function modelFromJson(item, mode) {
    if (isEmailTriggerItem(item)) {
        return {
            ...timestamp_json_1.TimestampsJsonMapper.fromJSON('createdAt' in item ? item : {}),
            eventDetailType: item.eventDetailType,
            eventMessageId: item.eventMessageId,
            eventSourceType: item.eventSourceType,
            id: item.id,
            recipients: item.recipients,
            templateData: item.templateData,
            templateId: item.templateId,
        };
    }
    else if (mode === 'data-only') {
        return undefined;
    }
    else {
        return isEmailTriggerItem.errors ?? [];
    }
}
/**
 * Create a JSON representation of a `EmailTrigger`.
 * @param record to convert to JSON
 * @returns a JSON represenation of `EmailTrigger`.
 */
function modelToJson(record) {
    return {
        ...timestamp_json_1.TimestampsJsonMapper.toJSON(record),
        eventDetailType: record.eventDetailType,
        eventMessageId: record.eventMessageId,
        eventSourceType: record.eventSourceType,
        id: record.id,
        recipients: record.recipients,
        templateData: record.templateData,
        templateId: record.templateId,
    };
}
exports.EmailTriggerJsonMapper = {
    fromJSON: modelFromJson,
    toJSON: modelToJson,
};
